import { DocumentCivilStatusCitizenshipUploadCrumbs } from 'civil-status/constants/breadcrumb';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormDocumentCitizenshipUploadNew from 'civil-status/components/upload-document-citizenship-form';
import { transformUploadCitizenshipNewPage } from 'civil-status/utils/transform-upload-new-act';
import { DocumentCitizenshipUploadFormVM } from 'civil-status/view-models/document-citizenship-form';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

export default function DocumentCitizenshipUploadNewPage(): React.ReactElement {
  const insert = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/atti-cittadinanza-sima/caricamento-atto-cittadinanza/inesistente`,
    {
      options: { method: 'POST', loading: true, errorCatching: true },
    }
  );

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: DocumentCitizenshipUploadFormVM | undefined) => {
      const data = transformUploadCitizenshipNewPage(formValues);
      (
        insert({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/cittadinanza');
      });
    },
    [insert, navigate]
  );
  return (
    <>
      <Breadcrumbs items={DocumentCivilStatusCitizenshipUploadCrumbs} base="stato-civile" />
      <FormDocumentCitizenshipUploadNew
        title="Caricamento Nuovo Atto"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/stato-civile/cittadinanza');
        }}
      />
    </>
  );
}

DocumentCitizenshipUploadNewPage.displayName = 'home page component';
